import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import "./BasicInformationStyle.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCountry,
  getIndividualPlans,
  getPolicyDocumentsEnglishMedical,
} from "../../Redux/IndividualMedicalRedux";
import Select from "react-select";
import { getAffrodablePlans } from "../../Redux/AffordableMedicalRedux";
import { getUnifiedHealthPlans } from "../../Redux/UnifiedDomesticRedux";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import IndividualMedical from "../Plans/IndividualMedical";
import {
  updateCoverPlanMedical,
  updateLeadsMedical,
} from "../../Redux/LogsRedux/Medical/MedicalLeadsRedux";
import CustomModal from "../Common/CustomModal/CustomModal";
import AffordableHealthPlan from "../Plans/AffordableHealthPlan/AffordableHealthPlan";
import UnifiedDomesticWorker from "../Plans/UnifiedDomesticWorker/UnifiedDomesticWorker";

function BasicInformation() {
  // Nationality field state and options
  const [formData, setFormData] = useState({ nationality: "OMANI" });
  const [country, setCountry] = useState([]);
  const [fileName, setFileName] = useState();
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleSelectChange = (selected, action) => {
    if (!action || !action.name) return;
    const { name } = action;
    const value = selected ? (selected.value ?? selected) : "";
    if (showPlan) {
      setShowPlan(false);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const dispatch = useDispatch();

  const today = dayjs();
  const minDobDate = today.subtract(60, "year");
  const maxDobDate = today.subtract(18, "year");

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [gender, setGender] = useState("");
  const [married, setMarried] = useState("");
  const [message, setMessage] = useState("");
  const [showPlan, setShowPlan] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);
  const location = useLocation();
  const { planDetails } = location.state || {};
  const showPlansFromState = Boolean(location.state?.showPlans);

  useEffect(() => {
    if (planDetails?.basicInfo) {
      setGender(planDetails.basicInfo.gender || "");
      setMarried(planDetails.basicInfo.married || "");
      setDob({
        year: planDetails.basicInfo.dob
          ? planDetails.basicInfo.dob.split("-")[2]
          : "",
        month: planDetails.basicInfo.dob
          ? new Date(
              `${planDetails.basicInfo.dob.split("-")[2]}-${
                planDetails.basicInfo.dob.split("-")[1]
              }-01`,
            ).toLocaleString(undefined, { month: "short" })
          : "",
        day: planDetails.basicInfo.dob
          ? parseInt(planDetails.basicInfo.dob.split("-")[0], 10)
          : "",
      });
    }
  }, []);

  useEffect(() => {
    if ( showPlansFromState ) {
      setSelectedPlanDetails(planDetails);
      setShowPlan(true);
    }
  }, [planDetails, showPlansFromState]);

  const [dob, setDob] = useState({
    year: "",
    month: "",
    day: "",
  });

  // Generate month names dynamically and a reasonable year range
  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) =>
      new Date(0, i).toLocaleString(undefined, { month: "short" }),
    );
  }, []);

  const handleDobChange = (value) => {
    if (showPlan) {
      setShowPlan(false);
    }
    if (!value) {
      setDob({ year: "", month: "", day: "" });
    } else {
      const [year, month, day] = value.split("-");
      const monthIndex = Number(month) - 1;
      const monthName = months[monthIndex] ?? "";
      setDob({
        year: year || "",
        month: monthName,
        day: day ? parseInt(day, 10) : "",
      });
    }
    if (message) {
      setMessage("");
    }
  };


  const dobString =
    dob.day && dob.month && dob.year
      ? `${String(dob.day).padStart(2, "0")}-${String(
          months.indexOf(dob.month) + 1,
        ).padStart(2, "0")}-${dob.year}`
      : "";

  // Calculate age from DOB
  const getAge = () => {
    if (!dob.day || !dob.month || !dob.year) return "";
    const monthIndex = months.indexOf(dob.month) + 1;
    const today = new Date();
    const birthDate = new Date(
      `${dob.year}-${String(monthIndex).padStart(2, "0")}-${String(
        dob.day,
      ).padStart(2, "0")}`,
    );
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() + 1 - monthIndex;
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };
  const age = getAge();
  const selectedDobDate =
    dob.year && dob.month && dob.day
      ? dayjs(
          `${dob.year}-${String(months.indexOf(dob.month) + 1).padStart(
            2,
            "0",
          )}-${String(dob.day).padStart(2, "0")}`,
        )
      : null;

  useEffect(() => {
    if (planDetails?.coverPlan == "Unified Domestic Worker") {
      dispatch(getCountry()).then((result) => {
        if (result && result.success) {
          setCountry(Array.isArray(result.data) ? result.data : []);
        }
      });
    }
  }, []);

  const handleSubmit = () => {
    const requireNationality =
      planDetails?.coverPlan == "Unified Domestic Worker";

    if (
      !gender ||
      !dob.year ||
      !dob.month ||
      !dob.day ||
      !married ||
      (requireNationality && !formData?.nationality)
    ) {
      setMessage("Please select all the fields");
      return;
    }
     else if (age <18) {
      setMessage("Age should be more than 18");
      return;
    } 
    else {
      setMessage("");
      const data = {
        gender,
        married: married || "",
        dob: dobString,
        ...(planDetails?.coverPlan == "Unified Domestic Worker" && {
          nationality: formData?.nationality,
        }),
      };
      const payload = {
        transId: localStorage.getItem("MEDICAL_LEAD_ID"),
        selectedInsuredDetails: data,
        leadStatus: "UPDATED",
      };
      if (planDetails?.coverPlan === "Individual Medical") {
        dispatch(getIndividualPlans(data)).then((result) => {
          if (result?.success) {
            dispatch(updateLeadsMedical(payload)).then((response) => {
              if (response?.success) {
                const updatedData = {
                  ...planDetails,
                  basicInfo: data,
                  individualPlans:
                    result?.data || planDetails?.individualPlans || {},
                };

                setSelectedPlanDetails(updatedData);
                setShowPlan(true);
              }
            });
          }
        });
      } else if (planDetails?.coverPlan == "Affordable Health Cover") {
        dispatch(getAffrodablePlans(data)).then((result) => {
          if (result.success) {
            dispatch(updateLeadsMedical(payload)).then((response) => {
              if (response.success) {
                const updatedData = {
                  ...planDetails,
                  basicInfo: data,
                  affordablePlans: result.data,
                };
                setSelectedPlanDetails(updatedData);
                setShowPlan(true);
              }
            });
          }
        });
      } else if (planDetails?.coverPlan == "Unified Domestic Worker") {
        dispatch(getUnifiedHealthPlans(data)).then((result) => {
          if (result.success) {
            dispatch(updateLeadsMedical(payload)).then((response) => {
              if (response.success) {
                const updatedData = {
                  ...planDetails,
                  basicInfo: data,
                  unifiedPlans: result.data,
                };
                setSelectedPlanDetails(updatedData);
                setShowPlan(true);
              }
            });
          }
        });
        // const updatedData = {
        //   ...planDetails,
        //   basicInfo: data,
        // };
        // navigate("/plans/health/unified-domestic-worker", {
        //   state: { planDetails: updatedData },
        // });
      }
    }
  };

  const handlePreview = async (policy, fileName) => {
   setFileName(policy.filename);

    try {
      const res = await dispatch(getPolicyDocumentsEnglishMedical(policy.link));

      if (!res || !res.data) {
        throw new Error("No document data received");
      }

      const pdfUrl = res.data;

      // Keep original URL for download
      setSelectedPdf(pdfUrl);

      // ❌ REMOVE THIS (causes CORS error)
      // const response = await fetch(pdfUrl);

      // ✅ USE PROXY INSTEAD
      const proxyUrl = `${process.env.REACT_APP_API_URL}/proxy-pdf?url=${encodeURIComponent(pdfUrl)}`;

      setPreviewUrl(proxyUrl);

      setIsSummaryOpen(true);

    } catch (err) {
      console.error("PDF preview failed:", err);
    }
  };

  const downloadDetails = [
    {
      label: "view table of benefits",
      link: "table-of-benefits",
      filename: "Table Of Benefits",
    },
    {
      label: "view covid-19 terms and conditions",
      link: "covid-19-terms-and-conditions",
      filename: "Covid-19 Terms And Condition",
    },
    {
      label: "view exclusion list",
      link: "policy-exclusion",
      filename: "Exclusion List",
    },
    {
      label: "view network list",
      link: "network-list",
      filename: "Network List",
    },
  ];

  const downloadDetailsUnified = [
    {
      label: "view table of benefits",
      link: "table-of-benefits-domestic",
      filename: "Table Of Benefits",
    },
    {
      label: "view covid-19 terms and conditions",
      link: "covid-19-terms-and-conditions",
      filename: "Covid-19 Terms And Condition",
    },
    {
      label: "view exclusion list",
      link: "policy-exclusion-domestic",
      filename: "Exclusion List",
    },
    {
      label: "view network list",
      link: "network-list-domestic",
      filename: "Network List",
    },
  ];

  const downloadDetailsAffordable = [
    {
      label: "view table of benefits",
      link: "table-of-benefits-affordable",
      filename: "Table Of Benefits",
    },
    {
      label: "view covid-19 terms and conditions",
      link: "covid-19-terms-and-conditions",
      filename: "Covid-19 Terms And Condition",
    },
    {
      label: "view exclusion list",
      link: "policy-exclusion-affordable",
      filename: "Exclusion List",
    },
    {
      label: "view network list",
      link: "network-list-affordable",
      filename: "Network List",
    },
  ];

  const currentDownloadDetails =
    planDetails?.coverPlan === "Unified Domestic Worker"
      ? downloadDetailsUnified
      : planDetails?.coverPlan === "Affordable Health Cover"
        ? downloadDetailsAffordable
        : [];

  return (
    <>
      <CustomModal
        isOpen={isSummaryOpen}
        onClose={() => {
          setIsSummaryOpen(false);
          setSelectedPdf(null);
          if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
            setPreviewUrl(null);
          }
        }}
        title={fileName}
        download={true}
        pdfUrl={selectedPdf}
      >
        <div
          className="modal-body"
          style={{ overflow: "hidden", padding: 0, height: "70vh" }}
        >
          {previewUrl && (
            <iframe
              title="View Document"
              src={`${previewUrl}#page=1&toolbar=0`}
              width="100%"
              height="95%"
              style={{ border: "none" }}
            />
          )}
        </div>
      </CustomModal>
      <div className="row">
        <div className="col-md-12">
          <h3 className="title pt-4 mb-2">{t(planDetails?.coverPlan)}</h3>
          <h5 className="title subHeader fw-bold py-1 ">
            {t("Enter insured details")}
          </h5>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 p-3 pb-0">
          <div
            className={`row d-flex justify-content-center ${
              planDetails?.coverPlan === "Unified Domestic Worker"
                ? "gap-3"
                : "gap-5"
            }`}
          >
            <div
              className={`section ${
                planDetails?.coverPlan === "Unified Domestic Worker"
                  ? "col-md-3"
                  : "col-md-3"
              } mb-0 border rounded-4 p-3`}
            >
              <label className="section-label fw-bold mb-2">
                {t("gender")}
              </label>
              <div className="option-group">
                <button
                  type="button"
                  className={`option ${gender === "male" ? "active" : ""} `}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setGender("male");
                    if (message) setMessage("");
                  }}
                >
                  <i className="bi bi-gender-male"></i> {t("male")}
                </button>
                <button
                  type="button"
                  className={`option ${gender === "female" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setGender("female");
                    if (message) setMessage("");
                  }}
                >
                  <i className="bi bi-gender-female"></i> {t("female")}
                </button>
              </div>
            </div>
            <div
              className={`section ${
                planDetails?.coverPlan === "Unified Domestic Worker"
                  ? "col-md-2"
                  : "col-md-3"
              } mb-0 border rounded-4 p-3`}
            >
              <label className="section-label fw-bold  mb-2">
                {t("are you married")}
              </label>
              <div className="option-group">
                <button
                  type="button"
                  className={`option ${married === "yes" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setMarried("yes");
                    if (message) setMessage("");
                  }}
                >
                  {t("yes")}
                </button>
                <button
                  type="button"
                  className={`option ${married === "no" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setMarried("no");
                    if (message) setMessage("");
                  }}
                >
                  {t("no")}
                </button>
              </div>
            </div>
            {planDetails?.coverPlan == "Unified Domestic Worker" && (
              <div className="section col-md-3 border rounded-4 p-3 mb-0">
                <label className="form-label fw-bold mb-2">
                  {t("nationality")}
                </label>
                <Select
                  name="nationality"
                  isClearable
                  options={
                    country && country.length
                      ? country.map((c) => ({ value: c, label: c }))
                      : []
                  }
                  value={
                    formData.nationality
                      ? {
                          value: formData.nationality,
                          label: formData.nationality,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    handleSelectChange(selected, { name: "nationality" });
                    if (message) setMessage("");
                  }}
                  placeholder="Select Nationality"
                />
              </div>
            )}
            <div className="section dob col-md-2 mb-0 border rounded-4 p-3">
              <label className="section-label fw-bold mb-2">
                {t("date of birth")}
              </label>
              <div className="dob-group ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDobDate ? dayjs(selectedDobDate) : null}
                    onChange={(value) => {
                      if (!value || !value.isValid()) {
                        handleDobChange("");
                        return;
                      }
                      handleDobChange(value.format("YYYY-MM-DD"));
                    }}
                    format="DD-MM-YYYY"
                    minDate={minDobDate}
                    maxDate={maxDobDate}
                    views={["year", "month", "day"]}
                    slotProps={{
                      textField: {
                        className: "form-control",
                        fullWidth: true,
                        sx: {
                          "& .MuiInputBase-root": {
                            height: 45,
                          },
                        },
                        // onKeyDown: (e) => e.preventDefault(), // disable manual typing
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
            {dob.year && dob.month && dob.day && (
              <div className="col-md-1 border rounded-4 p-3">
                <div className="">
                  <label className="section-label fw-bold mb-2 ">
                    {t("Age")}
                  </label>
                  <input
                    type="text"
                    className="form-control input-height"
                    value={age}
                    style={{
                      height: "45px",
                      padding: "10px",
                    }}
                    disabled
                  />
                </div>
              </div>
            )}
          </div>
          {planDetails?.coverPlan !== "Individual Medical" && (
            <div className="mt-3 d-flex flex-wrap align-items-center justify-content-center">
              {currentDownloadDetails &&
                !showPlan &&
                currentDownloadDetails.map((download, index) => (
                  <span
                    key={download.label}
                    className="d-flex align-items-center"
                  >
                    <i className="bi bi-file-earmark-text me-1"></i>

                    {download.link ? (
                      <a
                        href={download.link}
                        className="download-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePreview(download);
                        }}
                      >
                        {t(download.label)}
                      </a>
                    ) : (
                      <a href="#" className="download-link">
                        {t(download.label)}
                      </a>
                    )}

                    {/* Separator */}
                    {index !== currentDownloadDetails.length - 1 && (
                      <span className="mx-2">||</span>
                    )}
                  </span>
                ))}
            </div>
          )}
          {message && <p className="mt-1 text-danger p-0 m-0">{t(message)}</p>}
          {!showPlan && (
            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mb-4 mt-3"
              >
                {t("View Plans")}
              </button>
            </div>
          )}

          {/* <button type="button" className="view-btn" onClick={handleSubmit}>
            View Plans
          </button> */}
        </div>
      </div>

      {showPlan && planDetails?.coverPlan == "Individual Medical" && (
        <IndividualMedical planDetails={selectedPlanDetails} />
      )}

      {showPlan && planDetails?.coverPlan == "Affordable Health Cover" && (
        <AffordableHealthPlan planDetails={selectedPlanDetails} />
      )}

      {showPlan && planDetails?.coverPlan == "Unified Domestic Worker" && (
        <UnifiedDomesticWorker planDetails={selectedPlanDetails} />
      )}
    </>
  );
}

export default BasicInformation;
